import { QueryListParams } from '../types';

export const optoutsKeys = {
  optouts: (params?: QueryListParams) => ['OPTOUTS', params] as const,
};
